import { render } from "./PaymentHome.vue?vue&type=template&id=633dda05"
import script from "./PaymentHome.vue?vue&type=script&lang=js"
export * from "./PaymentHome.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pip-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__